import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
// Material UI
import {
  Typography
} from '@mui/material';
// Actions
import {
  deleteSubUser,
  deleteSubUsers,
} from "Redux/actions";
//Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import Button from 'Components/Button';

const DeleteSubUser = (props) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  //Props
  const { onShow, onClose, subUsers, loading, pagination } = props;

  const onSubmit = () => {
    if (subUsers.length == 1) {
      dispatch(
        deleteSubUser({
          items: subUsers
        }));
    } else {
      dispatch(
        deleteSubUsers({
          ids: subUsers.map((subUser) => subUser.id)
        }));
    }
    pagination?.onSearchText('')
  }

  return (
    <Modal
      size="small"
      loading={loading}
      open={onShow}
      handleClose={() => onClose()}
      title={messages['subUser_deleteUser']}
      position="right"
    >
      <ModalBody>
        <div style={{ padding: 24 }}>
          <Typography
            variant="subtitle2"
            color="textSecondary"
          >
            {`${messages['subUser_messageDelete']}?`}
          </Typography>
          <ul>
            {subUsers?.map((item, key) => {
              return (
                <li key={key}>
                  {item.userName}
                </li>
              )
            })}
          </ul>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          id={'btn-cancel-vehicle'}
          type="button"
          onClick={() => onClose()}
          className="btn-cancel"
        >
          {messages['subUser_cancel']}
        </Button>

        <Button
          id={'btn-schedule'}
          type="button"
          onClick={() => onSubmit()}
          className="btn-red"
        >
          {messages['subUser_delete']}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteSubUser;